<main
  class="flex justify-center items-center min-h-80vh pt-not-auth-header-m md:pt-not-auth-header-d"
>
  <ib-spinner *ngIf="checkCodeLoading" [diameter]="15"></ib-spinner>
  <div *ngIf="!checkCodeLoading && checkCodeError && !passwordReseted">
    <div class="flex justify-center">
      <i class="material-icons text-60px text-error!">warning_amber</i>
    </div>
    <p class="mt-40px text-center">
      Link expired or invalid, please go to
      <a class="ib-link ib-link-secondary" [routerLink]="LOGIN_PATH">
        <b>{{ 'btn.login' | transloco }}</b>
      </a>
      page and try reset password again
    </p>
  </div>

  <div *ngIf="!checkCodeLoading && !checkCodeError && passwordReseted">
    <div class="flex justify-center">
      <i class="material-icons text-60px text-success!">check_circle</i>
    </div>
    <p class="mt-40px text-center text-secondary text-40px">Awesome!</p>
    <p class="mt-40px text-center">
      Your password has been reseted succesfully. Please
      <a class="mt-24px ib-link ib-link-secondary" [routerLink]="LOGIN_PATH">
        <b>{{ 'btn.login' | transloco }}</b>
      </a>
      with your new password.
    </p>
  </div>

  <form
    [hidden]="checkCodeLoading || checkCodeError || passwordReseted"
    [formGroup]="form"
    class="justify-center items-center max-w-450px"
  >
    <div class="text-24px text-center text-secondary">Reset Password</div>
    <ib-mat-form-field-wrap
      class="mt-40px"
      [formCtrlName]="SIGN_UP_FIELDS.PASSWORD"
      [formCtrl]="form.get(SIGN_UP_FIELDS.PASSWORD)"
      [htmlInputEl]="passw"
      [showPasswVisibilityBtn]="true"
      [tooltipText]="
        'Length of password from 8 to 100 characters. Must contain: At least one uppercase symbols, At least one lowercase symbols, At least one number, At least one specific symbol: ' +
        PASSWORD_SPECIFIC_SYMBOLS
      "
    >
      <mat-form-field>
        <mat-label>New Password</mat-label>
        <input
          matInput
          #passw
          id="password"
          type="password"
          formControlName="{{ SIGN_UP_FIELDS.PASSWORD }}"
          required
        />
      </mat-form-field>
    </ib-mat-form-field-wrap>

    <ib-mat-form-field-wrap
      [formCtrlName]="SIGN_UP_FIELDS.PASSWORD_REPEAT"
      [formCtrl]="form.get(SIGN_UP_FIELDS.PASSWORD_REPEAT)"
      [htmlInputEl]="passwRepeat"
      [showPasswVisibilityBtn]="true"
    >
      <mat-form-field>
        <mat-label>Re-enter New Password</mat-label>
        <input
          matInput
          #passwRepeat
          autocomplete="new-password"
          type="password"
          formControlName="{{ SIGN_UP_FIELDS.PASSWORD_REPEAT }}"
          required
        />
      </mat-form-field>
    </ib-mat-form-field-wrap>

    <footer class="mt-50px flex flex-col justify-center items-center">
      <ib-btn-wrap [isLoading]="loading">
        <button
          [disabled]="form.invalid || loading"
          mat-button
          class="ib-btn ib-btn-secondary"
          (click)="submit()"
        >
          {{ 'btn.reset' | transloco }}&nbsp;{{ 'base.password' | transloco }}
        </button>
      </ib-btn-wrap>
    </footer>
  </form>
</main>

<ib-footer></ib-footer>
